import { useQuery } from '@tanstack/react-query'

import { detectJoyfulSidecarExtension } from '@/features/auth/utils/detectSidecarExtension'

const SIDECAR_INSTALL_QUERY_KEY = ['joyful-sidecar-extension', 'is-installed']

// Pings the Joyful sidecar Chrome extension once per page load. While the
// ping is in flight (`isPending`), callers should treat the install state
// as unknown and hide install affordances so the CTA doesn't flash in for
// users who already have the extension.
export function useIsJoyfulSidecarExtensionInstalled(extensionId: string) {
  return useQuery({
    queryFn: () => {
      return detectJoyfulSidecarExtension(extensionId)
    },
    queryKey: [...SIDECAR_INSTALL_QUERY_KEY, extensionId],
    staleTime: Infinity,
  })
}
